import React from 'react'
import { Box, Paper, Typography, Divider } from '@material-ui/core'
import Pending from 'components/MyGivingPage/Tithes/Pending'
import Confirmed from 'components/MyGivingPage/Tithes/Confirmed'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import AlertWrapper from 'components/AlertWrapper'
import { useHistory } from 'react-router'

export default function Tithes() {
  const { push: redirect } = useHistory()
  const isCurrentlyTithing = useCurrentUserProp('tithedJars').length > 0
  const hasPendingTithes = useCurrentUserProp('unprocessedTithes').length > 0
  const hasConfirmedTithes = useCurrentUserProp('mostRecentProcessedTithes').length > 0

  return (
    <Box component={Paper} p={2}>
      <Typography gutterBottom align='center' variant='h6' component='h2'>
        Tithes
      </Typography>

      {!isCurrentlyTithing && (
        <AlertWrapper
          severity='warning'
          message='You are not currently tithing. Select causes to tithe to in community'
          actionHandler={() => { redirect('/home/community') }}
          actionText='go to community'
        />
      )}

      {hasPendingTithes && <Pending/>}
      {hasConfirmedTithes && hasPendingTithes && <Divider />}
      {hasConfirmedTithes && <Confirmed />}
      {!hasPendingTithes && !hasConfirmedTithes && (
        <Typography align='center' paragraph variant='body1'>
          You don't have any tithes yet!
        </Typography>
      )}
    </Box>
  )
}
